module.exports = __webpack_public_path__ + "my.f7c0c8f21198a24c36ff.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/my.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/my.svg
// module chunks = styles